import { Monitor, Moon, Sun } from "lucide-react";
import { useEffect, useState } from "react";

type Mode = "system" | "light" | "dark";

export function ThemeToggle() {
  const [mode, setMode] = useState<Mode>(() => (localStorage.getItem("flo-theme") as Mode) || "system");
  useEffect(() => {
    localStorage.setItem("flo-theme", mode);
    const dark = mode === "dark" || (mode === "system" && matchMedia("(prefers-color-scheme: dark)").matches);
    document.documentElement.dataset.theme = dark ? "dark" : "light";
  }, [mode]);
  return (
    <div className="theme-toggle" aria-label="Theme">
      {(["light", "system", "dark"] as Mode[]).map((item) => {
        const Icon = item === "light" ? Sun : item === "dark" ? Moon : Monitor;
        return <button className={mode === item ? "selected" : ""} onClick={() => setMode(item)} key={item} aria-label={`${item} theme`}><Icon size={17} /></button>;
      })}
    </div>
  );
}
